<script lang="ts">
    import { createBenefitTagState } from './BenefitTagState.svelte.ts';

    interface Props {
        variationId: string;
        bestVariationBenefit?: string;
        rule?: string;
    }

    /**
 *
 *
 *
 *
 */
    const { variationId, bestVariationBenefit, rule }: Props = $props();

    const benefitTag = createBenefitTagState(() => variationId);
</script>

{#if benefitTag.useVariationIdBenefit || bestVariationBenefit}
    <div class="reptile-sale-tags__benefit-tag">
        {#key variationId}
            <ft9-benefit-tag-v1
                data-secondary-action
                id={`${variationId}-benefit-tag`}
                current-context-dreson={rule}
                team="reptile"
                feature="tilelist"
                variation-id={benefitTag.useVariationIdBenefit ? variationId : undefined}
                data={benefitTag.useVariationIdBenefit ? undefined : bestVariationBenefit}
            ></ft9-benefit-tag-v1>
        {/key}
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens' as tokens;

    .reptile-sale-tags {
        &__benefit-tag {
            margin-top: -1.5px;
        }
    }
</style>
